import React from 'react';
export default function circle(props) {
  return (<svg xmlns="http://www.w3.org/2000/svg" width={props.size || "72.656"} height={props.size || "72"} style={props.style} viewBox="0 0 72.66 72">
    <ellipse cx="36.33" cy="36" rx="36.33" ry="36" />
  </svg>);
}